import React, { useMemo, useCallback } from "react";
import { Autocomplete } from "@costar/theme-ui-autocomplete";
import { Flex } from "@costar/theme-ui";
var getOptionLabel = function (o) { return o.resourceMessage; };
var componentsProps = {
    rootInput: {
        fontSize: "xxs",
        border: "unset",
        backgroundColor: "transparent",
    },
    input: {
        sx: {
            color: "primary",
        },
    },
    listbox: {
        backgroundColor: "neutral.lighter",
        fontSize: "xxs",
    },
    popover: {
        disableScrollLock: true,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
        },
        transformOrigin: {
            vertical: "bottom",
            horizontal: "right",
        },
    },
};
var fallbackOptions = [];
export var PageSize = function (props) {
    var onChange = props.onChange, options = props.options, selectedValue = props.selectedValue, view = props.view;
    var onChangeCB = useCallback(function (_event, val) {
        onChange && val && onChange(val.value);
    }, [onChange]);
    var value = useMemo(function () { return (options === null || options === void 0 ? void 0 : options.filter(function (o) { return o.value === selectedValue; })[0]) || (options === null || options === void 0 ? void 0 : options[0]); }, [options, selectedValue]);
    var marginTop = useMemo(function () {
        return view === "map" ? "xs" : 0;
    }, [view]);
    return (React.createElement(Flex, { id: "page-size", alignItems: "center", width: "8.5rem", mt: marginTop },
        React.createElement(Autocomplete, { "automation-id": "footer-page-size", onChange: onChangeCB, options: options !== null && options !== void 0 ? options : fallbackOptions, value: value, getOptionLabel: getOptionLabel, disableClearable: true, mode: "select", fixToInputWidth: true, componentsProps: componentsProps })));
};
export var MemoPageSize = React.memo(PageSize);
//# sourceMappingURL=PageSize.js.map